import { Box, Step, StepLabel, Stepper } from '@material-ui/core'
import { useInventoryStore } from 'lib/hooks/useInventoryStore'
import { useTranslation } from 'react-i18next'
import { INVENTORY_STEPS } from 'shared'
import { CircleStep } from './CircleStep'

interface InventoryStepperProps {
  direction: 'row' | 'column'
}

export const InventoryStepper = ({ direction }: InventoryStepperProps): JSX.Element => {
  const { t } = useTranslation()
  const activeStep = useInventoryStore((state) => state.step)

  const numKeys = Object.keys(INVENTORY_STEPS).length

  const VerticalStepper = (): JSX.Element => (
    <Box>
      {Object.keys(INVENTORY_STEPS).map((key) => {
        const { idx, label } = INVENTORY_STEPS[key]

        if (idx === 0) return null

        return (
          <Box key={key}>
            <CircleStep
              size="120px"
              text={t(`ptInventory.stepper.${label}`)}
              textSize="normal"
              active={idx <= activeStep}
              showArrow={idx < numKeys - 1}
              arrowType={idx % 2 === 0 ? 'left' : 'right'}
            />
          </Box>
        )
      })}
    </Box>
  )

  const HorizontalStepper = (): JSX.Element => (
    <Stepper activeStep={activeStep} alternativeLabel className="almost-custom-stepper">
      {Object.keys(INVENTORY_STEPS).map((key) => {
        const { idx, label } = INVENTORY_STEPS[key]

        if (idx === 0) return null
        const stepProps: { completed?: boolean } = {}
        return (
          <Step key={key} {...stepProps}>
            <StepLabel>{t(`ptInventory.stepper.${label}`)}</StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )

  return <>{direction === 'column' ? <VerticalStepper /> : <HorizontalStepper />}</>
}
